<div class="search-bar">
  <input
    type="text"
    [formControl]="searchControl"
    [placeholder]="placeholder"
  />
  <button
    *ngIf="hasSearchValue()"
    type="button"
    class="clear-button"
    aria-label="Limpiar búsqueda"
    (click)="clearSearch()"
  >
    ×
  </button>
  <div class="icon">
    <img src="assets/static/icons/search.svg" alt="Search" />
  </div>
</div>
